import {Body2} from "../../components/Font";
import {LanguageEnum} from "../../enum/language";
import {FixedBottomBlock} from "../../components/ui/Content";
import React from "react";
import {useTranslation} from "react-i18next";
import {LocalStorageEnum} from "../../enum/localStorage";


export const LanguageSelector = () => {

    const {i18n} = useTranslation();

    const setLang = (lang: LanguageEnum) => {
        return() => {localStorage.setItem(LocalStorageEnum.lang, lang)
            i18n.changeLanguage(lang)}
    }

    const setActive = (lang: LanguageEnum) => `${i18n.language === lang ? 'tertiary' : 'secondary'} pointer`

    return <FixedBottomBlock>
        <Body2
            className={setActive(LanguageEnum.Ru)}
            onClick={setLang(LanguageEnum.Ru)}>Русский</Body2>
        <Body2
            className={setActive(LanguageEnum.En)}
            onClick={setLang(LanguageEnum.En)}>English</Body2>
    </FixedBottomBlock>
}
